// Classi condivise dai template dell'area gestionale: stesso vocabolario della home e del selettore lingua
// (avorio, inchiostro, filetti d'oro, maiuscoletto di Cormorant, ombre morbide). Token in src/index.css.

/** Titolo di pagina: Cormorant semibold, mai sotto i 36px (sotto quella misura si usa Jost). */
export const pageTitleClass = 'font-display text-4xl leading-tight font-semibold text-ink sm:text-[2.75rem]'

/** Superficie principale (tabelle, form, dialoghi): cartoncino d'avorio con filetto sottile e ombra morbida. */
export const surfaceClass = 'rounded-3xl border border-line bg-paper shadow-card'

/** Intestazione di una superficie in maiuscoletto d'oro, come "Lingua" nel selettore; di solito seguita da `.ticket-perforation` (filetto doppio). */
export const stripClass = 'inscription bg-paper-deep/60 text-base text-sea-ink'

/** Piede di form e dialoghi con le azioni, sotto una `.ticket-perforation`. */
export const stubClass = 'flex flex-wrap items-center justify-end gap-3 bg-paper-deep/70 px-5 py-4 sm:px-6'

export const errorClass = 'rounded-lg border border-coral/60 bg-coral/10 px-4 py-3 text-sm text-coral-ink'

// Altezza fissa (38px) uguale per input, date e select; leading-6 lascia spazio alle discendenti
// (le "g" di gg/mm/aaaa), che Firefox taglia nei campi data con alcuni font di sistema.
// Bordo ink-soft: il contorno di un campo deve avere contrasto 3:1 sulla carta.
export const inputClass =
  'h-9.5 w-full rounded-xl border border-ink-soft/60 bg-paper px-3 py-1.5 text-sm leading-6 text-ink placeholder:text-ink-soft/70 transition-colors focus:border-sun-ink focus:outline-none focus:ring-2 focus:ring-sun/35 disabled:bg-paper-deep disabled:text-ink-soft'

export const labelClass = 'mb-1.5 block text-sm font-medium text-ink'

export const hintClass = 'mt-1.5 block text-xs text-ink-soft'

/** Casella di spunta nel colore dell'inchiostro. */
export const checkboxClass = 'size-4 accent-ink disabled:opacity-50'

const button =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium tracking-[0.02em] transition-[background-color,border-color,color,translate] duration-150 active:translate-y-px disabled:cursor-not-allowed disabled:opacity-50 disabled:active:translate-y-0'

export const primaryButton = `${button} border-coral bg-coral text-white hover:border-coral-ink hover:bg-coral-ink`
/** Come "Area riservata" nell'header del sito: filetto d'oro che si scalda al passaggio. */
export const secondaryButton = `${button} border-line bg-paper text-ink hover:border-sea hover:bg-sea/10`
/** Azione alternativa accanto a quella principale (es. "Invita utente" accanto a "Nuovo utente"). */
export const outlineButton = secondaryButton
export const dangerButton = `${button} border-coral-ink bg-coral-ink text-paper hover:bg-coral-ink/85`

export const iconButton = 'inline-flex rounded-2xl p-2 text-ink-soft transition-colors hover:bg-ink/5 hover:text-ink'

export const linkButton = 'rounded text-sm font-medium text-sea-ink underline-offset-4 hover:underline'

/** Etichetta di stato o categoria nelle tabelle; il tono si aggiunge (es. `bg-sea/15 text-sea-ink`). */
export const badgeClass = 'inline-flex items-center gap-1.5 rounded-2xl px-2 py-0.5 text-xs font-medium'
